import { Component, Input } from "@angular/core";
import {
  PathLocationStrategy,
  Location,
  LocationStrategy
} from "@angular/common";

@Component({
  selector: "toolbar-heading",
  templateUrl: "./toolbar-heading.component.html",
  styleUrls: ["./toolbar-heading.component.scss"],
  providers: [
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ]
})
export class ToolbarHeadingComponent {
  @Input() heading: string;
  @Input() showBackButton: boolean = false;

  constructor(private _location: Location) {}

  goBack(): void {
    this._location.back();
  }
}
